import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-workshop-depots',
    templateUrl: './workshop-depots.component.html',
    styleUrls: ['./workshop-depots.component.scss'],
    standalone: false
})
export class WorkshopDepotsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
